export default __webpack_public_path__ + "images/entree_button.png";